module.exports = __webpack_public_path__ + "img/driver1.a595c29e.png";